import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";

type AvailableFeatureState =
  | string
  | number
  | boolean
  | Record<string, unknown>
  | unknown[]
  | null
  | undefined;

/**
 * AvailableFeaturesStateService
 * --------------------------------------------------------------------
 * Cross-cutting streams that describe the set of features the device
 * exposes, plus the direct-feature selection and Luminfo version.
 * Also owns `configurationData` and `isConfigData` because they're the
 * primary read-flow signal.
 */
@Injectable({ providedIn: "root" })
export class AvailableFeaturesStateService {
  readonly availableFeatures = new BehaviorSubject<AvailableFeatureState>("");
  readonly getAvailableFeature: Observable<AvailableFeatureState> = this.availableFeatures.asObservable();
  readonly availableFeaturesMulti = new BehaviorSubject<AvailableFeatureState>("");
  readonly getAvailableFeatureMulti: Observable<AvailableFeatureState> =
    this.availableFeaturesMulti.asObservable();

  listOfAvailableFeatures: string[] = [];

  readonly directFeature = new BehaviorSubject<AvailableFeatureState>("");
  readonly getdirectFeature: Observable<AvailableFeatureState> = this.directFeature.asObservable();

  readonly configurationData = new BehaviorSubject<AvailableFeatureState>("");
  readonly getConfigurationData: Observable<AvailableFeatureState> = this.configurationData.asObservable();
  readonly getconfigData: Observable<AvailableFeatureState> = this.configurationData.asObservable();

  readonly isConfigData = new BehaviorSubject<AvailableFeatureState>("");
  readonly checkConfigData: Observable<AvailableFeatureState> = this.isConfigData.asObservable();

  // --- Luminfo -----------------------------------------------------
  private readonly luminfoVersionSubject = new BehaviorSubject<number>(0);
  readonly luminfoVersion$: Observable<number> = this.luminfoVersionSubject.asObservable();
  readonly luminfoVersionChanged = new Subject<number>();

  sendFeatures(data: AvailableFeatureState): void {
    this.availableFeatures.next(data);
  }
  sendMultiFeatures(data: AvailableFeatureState): void {
    this.availableFeaturesMulti.next(data);
  }
  getListOfAvailableFeatures(): string[] {
    return this.listOfAvailableFeatures;
  }
  setListOfAvailableFeatures(features: string[]): void {
    this.listOfAvailableFeatures = features;
  }
  sentdirectlyFeature(data: AvailableFeatureState): void {
    this.directFeature.next(data);
  }

  setConfigurationData(data: AvailableFeatureState): void {
    this.configurationData.next(data);
  }
  sentConfigurationData(data: AvailableFeatureState): void {
    this.configurationData.next(data);
  }
  modalConfigurationData(data: AvailableFeatureState): void {
    this.configurationData.next(data);
  }
  setConfig(data: AvailableFeatureState): void {
    this.isConfigData.next(data);
  }

  setLuminfoVersion(version: number): void {
    this.luminfoVersionSubject.next(version);
  }
  getLuminfoVersion(): number {
    return this.luminfoVersionSubject.getValue();
  }
}
